import { useInfiniteQuery, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { projectedCrossKeys } from '../queries/keys';
import { projectedCrossPaths } from '../queries/paths';

// TSS vite/03 — cruces proyecto (admin-projected-crosses.md): plantilla donadora × toro
// (ambos animales) que aún no nació y se vende N veces. Permiso: projected_crosses:read/write.

// Página por defecto del listado (contrato: limit def 50 / máx 500).
const LIST_LIMIT = 50;

export function useProjectedCrossesList(filters) {
    return useQuery({
        queryKey: projectedCrossKeys.list(filters),
        queryFn:  ({ signal }) => api.get(projectedCrossPaths.list(), { params: filters, signal }).then(r => r.data),
        placeholderData: (prev) => prev,
    });
}

// Listado paginado "cargar más" (offset). Páginas acumuladas en TanStack Query —
// vite/03 [RIGID]. Reemplaza el limit:500 + aviso de truncado del overview.
export function useProjectedCrossesInfinite(filters, limit = LIST_LIMIT) {
    return useInfiniteQuery({
        queryKey: projectedCrossKeys.infinite(filters, limit),
        queryFn:  ({ pageParam, signal }) =>
            api.get(projectedCrossPaths.list(), { params: { ...filters, limit, offset: pageParam }, signal }).then(r => r.data),
        initialPageParam: 0,
        getNextPageParam: (last) => {
            const p = last?.pagination;
            if (!p) return undefined;
            const next = p.offset + p.limit;
            return next < p.total ? next : undefined;
        },
        placeholderData: (prev) => prev,
    });
}

export function useCreateProjectedCross() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post(projectedCrossPaths.list(), payload).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: projectedCrossKeys.all }),
    });
}

// PATCH: solo name/capacity/expected_window/status/remarks (donor/sire/code inmutables).
export function useUpdateProjectedCross(id) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.patch(projectedCrossPaths.detail(id), payload).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: projectedCrossKeys.all }),
    });
}

export function useDeleteProjectedCross() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => api.delete(projectedCrossPaths.detail(id)).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: projectedCrossKeys.all }),
    });
}
